import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RevokeDecisionPopup', {
    revokeButtonText: 'Revoke',
    descriptionText:
        'Please provide a comment, so that {authorName} as well as the Approvers know why the request has been revoked.',
    popupTitle: `Revoke the decision for "{requestName}".`,
    revokeButtonTitle: 'Revoke request',
});
